var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98610",
    "data-name": "Group 98610",
    transform: "translate(-272 -553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_911",
    "data-name": "Ellipse 911",
    transform: "translate(272 553)",
    fill: "#fff",
    stroke: "#e2e2f8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "booking",
    d: "M18.359,54.342l3.075,1.2-9.181,3.57L9.036,57.857l9.04-3.515A.375.375,0,0,1,18.359,54.342Zm9.576,10.268a4.676,4.676,0,1,1-4.676,4.676A4.676,4.676,0,0,1,27.935,64.611Zm1.77,2.543-2.77,2.77-.945-1.189a.677.677,0,0,0-1.059.842l1.391,1.75a.678.678,0,0,0,1.035.092l3.306-3.306a.678.678,0,1,0-.958-.958ZM24.718,56.815l-9.181,3.57,2.681,1.042,9.181-3.57Zm3.217,1.667-9.328,3.627v10.8l4.242-1.65a5.458,5.458,0,0,1,5.085-7.432ZM17.828,72.913v-10.8L15,61.01v2.281a.129.129,0,0,1-.213.1l-1.5-1.278-1.4.436a.129.129,0,0,1-.167-.123V59.733L8.5,58.482V69.02a.383.383,0,0,0,.249.363Z",
    transform: "translate(272.601 510.146)",
    fill: "#e2e2f8",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus55);
export default __webpack_public_path__ + "static/media/status55.25a6c9963fc998b6b6bae62fd35b5353.svg";
export { ForwardRef as ReactComponent };